import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate as translateConstructor } from '@haldor/ui';
import { submitForm } from 'actions/templates';
import { getStudentMentorGroups } from 'actions/sections';
import DisplayForm from '../Forms/DisplayForm';
import { Alert, Button, Box } from '@mui/material';
var LeaveApplicationForm = /*#__PURE__*/function (_Component) {
  function LeaveApplicationForm() {
    var _this;
    _classCallCheck(this, LeaveApplicationForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LeaveApplicationForm, [].concat(args));
    // Called by parent to request closing the form/modal.
    // Shows unsaved-changes prompt if needed by delegating to DisplayForm.
    _defineProperty(_this, "requestClose", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var ok, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(_this.displayFormRef && _this.displayFormRef.confirmClose)) {
              _context.next = 2;
              break;
            }
            _context.next = 1;
            return _this.displayFormRef.confirmClose();
          case 1:
            ok = _context.sent;
            if (ok) {
              if (_this.props.onAbort) _this.props.onAbort();
            }
            _context.next = 3;
            break;
          case 2:
            if (_this.props.onAbort) _this.props.onAbort();
          case 3:
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](0);
            // fallback: close
            if (_this.props.onAbort) _this.props.onAbort();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 4]]);
    })));
    _defineProperty(_this, "handleSubmit", function (data) {
      var _this$props = _this.props,
        user = _this$props.user,
        guardianId = _this$props.guardianId,
        submitForm = _this$props.submitForm;
      var studentId = user;
      var guardian = guardianId || _this.props.userId;
      if (!studentId || !guardian) {
        console.error('Missing studentId or guardianId');
        return Promise.reject(new Error('Missing required IDs'));
      }

      // Add title to the form data
      var formDataWithTitle = _objectSpread(_objectSpread({}, data), {}, {
        title: 'Leave Request'
      });
      return submitForm(formDataWithTitle, guardian, studentId);
    });
    return _this;
  }
  _inherits(LeaveApplicationForm, _Component);
  return _createClass(LeaveApplicationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        user = _this$props2.user,
        getStudentMentorGroups = _this$props2.getStudentMentorGroups;
      if (user) {
        getStudentMentorGroups(user);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        mentorGroups = _this$props3.mentorGroups,
        translations = _this$props3.translations;
      var translate = translateConstructor(translations);
      var showMentorInfo = Array.isArray(mentorGroups) && mentorGroups.length === 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, showMentorInfo && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Alert, {
        severity: "info",
        sx: {
          mb: 2
        }
      }, translate("To create a leave application, the student must belong to a mentor group. Please contact your school.")), /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        onClick: this.props.onAbort
      }, translate('Close'))), !showMentorInfo && /*#__PURE__*/React.createElement(DisplayForm, {
        ref: function ref(el) {
          _this2.displayFormRef = el;
        },
        type: "LEAVE_REQUEST",
        onCancel: this.props.onAbort,
        onSubmit: this.handleSubmit,
        onSuccess: this.props.onSuccess
      }));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  var _state$User$user;
  return {
    userId: (_state$User$user = state.User.user) === null || _state$User$user === void 0 ? void 0 : _state$User$user.id,
    mentorGroups: state.groups.mentorGroups,
    translations: state.Languages.translations
  };
}
export default connect(mapStateToProps, {
  submitForm: submitForm,
  getStudentMentorGroups: getStudentMentorGroups
}, null, {
  forwardRef: true
})(LeaveApplicationForm);